module.exports = __webpack_public_path__ + "static/media/BLUSH_5431.88108f8d.jpg";